<script setup>
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { usePage, Link } from '@inertiajs/vue3';
import { computed, onMounted, ref } from 'vue';
import axios from 'axios';
const page = usePage()

const services = ref([]);

async function getServices() {
    try {
        const res = await axios.get('/services-data');
        services.value = res.data || []; // Assign response data or keep empty object
    } catch (error) {
        console.error('Error fetching hero text:', error);
    }
}

onMounted(() => {
    getServices();
})

const isServicesPage = computed(() => page.url === '/services');
const displayedServices = computed(() => {
    if (isServicesPage.value) {
        return services.value; // Show all services on /services page
    } else {
        return services.value.slice(0, 6); // Show only 6 services on other pages
    }
});

</script>
<template>
    <section class="text-gray-600 body-font">
        <div class="container 2xl:px-24 xl:px-0 lg:py-8 py-2 mx-auto">
            <div class="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 gap-6 mb-2">
                <Link
                    class="shadow rounded-lg hover:shadow-xl border bg-white hover:bg-[#1cbed1] text-black hover:text-white transition duration-300 wow animate__animated animate__fadeInLeft"
                    :href="route('service.page', service?.slug)" v-for="service in displayedServices" :key="service.id">
                <div class="block overflow-hidden w-full xl:h-72 h-64 rounded-t-lg">
                    <VLazyImage :src="service?.image" :alt="service?.slug" class="w-full h-full object-cover transform hover:scale-110 transition duration-500"/>
                </div>
                <div class="xl:p-6 p-4 mx-auto">
                    <h2 class="title-font xl:text-[22px] lg:text-[18px] text-center font-light">{{ locale === 'BN' ? service?.bn_title : service?.title }}</h2>
                </div>
                </Link>
            </div>
        </div>
    </section>
</template>
<style scoped></style>
